// 共用 AI 疑難排解 i18n 命名空間（由子計劃 14 擁有）。子計劃 18/19/20 會擴充此命名空間，
// 加入各自獨立的鍵值子樹，而不會重新撰寫此檔案。
export const aiTroubleshooting = {
  title: 'AI 疑難排解',
  pageTitle: 'AI 疑難排解',
  subtitle: '描述問題徵狀，讓唯讀診斷 AI 進行調查。',
  menu: {
    investigate: '排查',
  },
  // 診斷手冊子項目的選單標籤（子計劃 18）。擴充此共用命名空間，
  // 而非新增獨立的 menu.aiPlaybooks 鍵（REF-08 s.5.5）。
  playbooks: '診斷手冊',
  form: {
    title: '新增調查',
    symptom: '問題徵狀',
    symptomPlaceholder: '描述發生的情況（例如：充電樁 CP123 在應用程式中顯示可用，但仍有使用中的充電時段）。',
    anchorType: '相關項目',
    anchorId: '項目 ID',
    anchorIdHelper: '從相關畫面貼上識別碼。',
    anchorIdHelperNone: '選擇相關項目類型以附加 ID。',
    anchorIdRequired: '所選項目類型需要填寫 ID。',
    run: '開始調查',
  },
  anchorType: {
    none: '無',
    charger: '充電樁',
    session: '充電時段',
    user: '使用者',
    transaction: '交易',
    reservation: '預約',
  },
  stream: {
    title: '調查步驟',
    investigating: '調查中...',
    waiting: '正在開始調查...',
    stop: '停止',
  },
  report: {
    title: '報告',
    refusedTitle: '請求已拒絕',
    refusedGeneric: '此請求超出充電系統疑難排解的範圍。',
    noConclusion: '未產生結論。',
    evidence: '佐證',
    model: '模型',
    tokens: 'Token（輸入 / 輸出）',
    cost: '費用',
    latency: '延遲',
  },
  refusedReason: {
    off_topic: '此請求與充電系統無關。',
    coding_request: '此助理不會撰寫或產生程式碼。',
    general_knowledge: '這是一般知識問題，而非充電系統問題。',
    jailbreak_attempt: '此請求試圖覆寫助理的指示。',
    out_of_domain_action: '此助理僅執行唯讀的疑難排解。',
  },
  category: {
    software_bug: '軟體錯誤',
    hardware_fault: '硬體故障',
    firmware_issue: '韌體問題',
    config: '設定問題',
    user_error: '使用者操作錯誤',
    network: '網路問題',
    unknown: '無法判定',
  },
  confidence: {
    high: '高信心度',
    medium: '中信心度',
    low: '低信心度',
  },
  status: {
    running: '進行中',
    completed: '已完成',
    failed: '失敗',
    refused: '已拒絕',
  },
  handoff: {
    copy: '複製除錯交接資料',
    download: '下載 .md',
    preview: '預覽除錯交接資料',
    copied: '除錯交接資料已複製到剪貼簿。',
    copyFailed: '無法複製到剪貼簿。',
  },
  history: {
    title: '調查記錄',
    refresh: '重新整理',
    empty: '尚無調查記錄。',
    loadFailed: '載入調查記錄失敗。',
    createdAt: '建立時間',
    status: '狀態',
    anchor: '項目',
    category: '類別',
    confidence: '信心度',
    model: '模型',
  },
  detail: {
    title: '調查詳情',
    close: '關閉',
    created: '建立時間',
    anchor: '項目',
    symptom: '問題徵狀',
    steps: '步驟',
    notFound: '找不到此調查，或您沒有存取權限。',
    loadFailed: '載入調查失敗。',
  },
  // AI 故障分析頁面（子計劃 19）。以自身的鍵值子樹擴充此共用命名空間；
  // 不重新定義 menu.aiTroubleshooting（由 14 擁有）或其他子樹（18/20）。
  analytics: {
    title: 'AI 故障分析',
    subtitle: '調查總數、隨時間的趨勢，以及重複出現的故障。',
    empty: '此期間沒有資料。',
    unknownModel: '未知型號',
    unknownSite: '未知站點',
    granularity: {
      label: '時間粒度',
      day: '日',
      week: '週',
    },
    cards: {
      totalInvestigations: '調查總數',
      refused: '已拒絕',
      refusalRate: '拒絕率',
      handoffs: '交接數',
      byCategory: '依類別',
      byStatus: '依狀態',
    },
    charts: {
      investigationsOverTime: '調查數量趨勢',
      recurringByCategory: '依類別的重複故障',
      recurringByModel: '依充電樁型號的重複故障',
      recurringBySite: '依站點的重複故障',
    },
    table: {
      site: '站點',
      model: '充電樁型號',
      category: '類別',
      count: '次數',
    },
    category: {
      software_bug: '軟體錯誤',
      hardware_fault: '硬體故障',
      firmware_issue: '韌體問題',
      config: '設定問題',
      user_error: '使用者操作錯誤',
      network: '網路問題',
      unknown: '無法判定',
      unclassified: '未分類',
    },
    status: {
      running: '進行中',
      completed: '已完成',
      failed: '失敗',
      refused: '已拒絕',
    },
    errors: {
      loadFailed: '載入分析資料失敗',
    },
  },
  // 模型 A/B 重播控制（子計劃 20）。以自身的鍵值子樹擴充此共用命名空間；
  // 不重新定義 menu.aiTroubleshooting（由 14 擁有）或其他子樹（18/19）。
  replay: {
    title: '以模型重播',
    subtitle: '以不同模型重新執行相同的問題徵狀與項目，以比較結果。',
    modelLabel: '模型',
    run: '重播',
    running: '重播執行中...',
    loadingModels: '載入模型中...',
    noModels: '尚未設定啟用中的調查模型。',
    success: '重播完成',
    errors: {
      investigationNotFound: '找不到此調查，或超出存取範圍。',
      modelNotFound: '所選模型已不可用；請選擇其他模型。',
      modelUnavailable: '所選模型目前無法使用。請選擇其他模型。',
      validation: '請求無效。',
      rateLimited: '已達速率限制。請稍後再試。',
      rateLimitedRetry: '已達速率限制。請於 %{seconds} 秒後再試。',
      generic: '重播失敗。',
    },
  },
  // 模型 A/B 並排比較（子計劃 20）。
  comparison: {
    title: '模型比較',
    notAvailable: 'N/A',
    original: '原始',
    status: '狀態',
    category: '類別',
    confidence: '信心度',
    conclusion: '結論',
    tokens: 'Token（輸入 / 輸出）',
    cost: '費用',
    latency: '延遲',
    symptom: '問題徵狀',
    anchor: '項目',
    singleRunHint: '以另一個模型執行重播以進行比較。',
    noRuns: '沒有可比較的執行結果。',
    notFound: '無法取得比較（找不到調查，或超出存取範圍）。',
    loadFailed: '載入比較失敗。',
  },
};
